import { useQuery } from '@tanstack/react-query';
import { fetchPublicPartners } from '@/api/partners';

export const PartnersSection = () => {
  const partners = useQuery({ queryKey: ['public', 'partners'], queryFn: fetchPublicPartners, staleTime: 5 * 60_000, retry: 1 });
  const items = partners.data?.items ?? [];
  const types = partners.data?.types ?? {};

  if (partners.isSuccess && items.length === 0) return null;

  return (
    <section aria-labelledby="partnerek-cim" className="pb-16 sm:pb-20">
      <div className="mx-auto w-full max-w-[1220px] px-4 sm:px-6">
        <div className="mx-auto mb-8 max-w-[56ch] text-center">
          <h2 id="partnerek-cim" className="text-2xl">
            Akikkel együtt dolgozunk
          </h2>
          <p className="mt-3 text-ink-soft">Háziápolási szolgáltatók, idősotthonok és orvosok, akikkel rendszeresen együttműködünk.</p>
        </div>

        <ul className="grid list-none grid-cols-2 gap-4 p-0 sm:grid-cols-3 lg:grid-cols-5">
          {(items.length > 0 ? items : Array.from({ length: 5 }, (_, index) => ({ id: `placeholder-${index}`, name: '', type: null, description: null, logoUrl: null, websiteUrl: null }))).map((partner) => {
            const card = partner.name ? (
              <span className="flex h-full flex-col items-center justify-center gap-2 p-4 text-center">
                {partner.logoUrl ? (
                  <img src={partner.logoUrl} alt={partner.name} loading="lazy" className="max-h-16 w-auto max-w-full object-contain" />
                ) : (
                  <span className="font-display text-lg font-bold text-navy">{partner.name}</span>
                )}
                {partner.type && types[partner.type] && <span className="text-xs text-ink-soft">{types[partner.type]}</span>}
              </span>
            ) : (
              <span className="grid h-full place-items-center text-sm text-ink-soft">Partner</span>
            );

            return (
              <li key={partner.id} className="min-h-24 rounded-lg border-2 border-line bg-paper">
                {partner.websiteUrl ? (
                  <a href={partner.websiteUrl} target="_blank" rel="noreferrer" className="block h-full no-underline hover:border-navy" title={partner.description ?? undefined}>
                    {card}
                  </a>
                ) : (
                  <div className="h-full" title={partner.description ?? undefined}>
                    {card}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
